import animatedScrollTo from "animated-scroll-to"
import { emitter } from '@/emitter'

emitter.on('scroll-to', (to) => {
    if (typeof to === 'string') {
        animatedScrollTo(document.querySelector(to))
    }

    if (typeof to === 'number' || to instanceof Element) {
        animatedScrollTo(to)
    }
})